<form [formGroup]="berekeningBox1FormGroup">
    <div formGroupName="box1">
        <div formGroupName="opbouwInkomen">
                <div class="row">
                    <div class="col col-1">
                        <p>Belastbaar loon</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control
                                formControlName="belastbaarloon"
                                id="belastbaarloon"
                                class="custom-input-150"
                                align="right"
                                [decimals]="0"
                                prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>

